import { StateCreator } from 'zustand'

import EStoreStateKeys from '~/models/store'

type TConversationDefinition = {
  expandedConversationId: string
}

type TConversation = {
  [EStoreStateKeys.conversation]: TConversationDefinition
}

export type TConversationState = TConversation & {
  setConversation(expandedConversationId: string): void
}

export const initialConversationState: TConversationDefinition = {
  expandedConversationId: '',
}

const createConversationSlice: StateCreator<
  TConversationState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  [EStoreStateKeys.conversation]: {
    expandedConversationId: initialConversationState.expandedConversationId,
  },
  setConversation: (urlConversationId) =>
    set(
      (state) => ({
        [EStoreStateKeys.conversation]: {
          ...state[EStoreStateKeys.conversation],
          expandedConversationId: urlConversationId,
        },
      }),
      undefined,
      {
        type: 'setConversation',
        urlConversationId,
      },
    ),
})

export default createConversationSlice
